// utils/notifications.js
const BASE_URL = process.env.REACT_APP_BASE_URL;

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = atob(base64);
  return Uint8Array.from([...rawData].map((char) => char.charCodeAt(0)));
}

// ✅ Subscribe to Push Notifications
export async function subscribeUserToPush() {
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
    console.warn("Push not supported");
    return;
  }

  try {
    // 🔁 Always re-register the service worker to clear stale state
    const registration = await navigator.serviceWorker.register("/service-worker.js");
    await navigator.serviceWorker.ready;

    // 🔄 Remove any old subscriptions before creating a new one
    const existing = await registration.pushManager.getSubscription();
    if (existing) {
      console.log("🧹 Cleaning old push subscription...");
      await existing.unsubscribe();
    }

    // 🔑 Get VAPID key
    const keyRes = await fetch(`${BASE_URL}/api/notifications/public-key`);
    const { publicKey } = await keyRes.json();

    // 🆕 Subscribe new
    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(publicKey),
    });

    // 📡 Send subscription to backend
    const res = await fetch(`${BASE_URL}/api/notifications/subscribe`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(subscription),
    });

    console.log("✅ Push subscription successful:", await res.json());
  } catch (err) {
    console.error("❌ subscribeUserToPush failed:", err);
  }
}

// ✅ Unsubscribe from push (used on logout)
export async function unsubscribeUserFromPush() {
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) return;

  try {
    const registration = await navigator.serviceWorker.ready;
    const subscription = await registration.pushManager.getSubscription();
    if (subscription) {
      await subscription.unsubscribe();
      console.log("✅ Unsubscribed from push notifications");
    }
  } catch (err) {
    console.error("❌ Failed to unsubscribe from push:", err);
  }
}
